import { createTaskConverter, newTaskConverter } from '@griply/services';
import { Task } from '@griply/types';
import { FirestoreDataConverter } from 'firebase/firestore';

import { getErrorReporter } from '../../error-tracking';

export const taskConverter = createTaskConverter({
  onError: (error, context) =>
    getErrorReporter().captureException(error, {
      tags: { source: 'schedule-rrule-invalid' },
      extra: context,
    }),
}) as unknown as FirestoreDataConverter<Task>;
export { newTaskConverter };
